import type { FC, ReactNode } from "react";

import { footerProvider } from "./FooterProvider";

export type FooterTranslations = {
  info: {
    rights: string;
    gamblingAddictive: string;
    playResponsibly: string;
    supportDescription: string;
    supportEmail: string;
  };
};

export const FooterTranslationProvider: FC<{
  value: FooterTranslations;
  children: ReactNode;
}> = (props) => {
  return (
    <footerProvider.Provider value={props.value}>
      {props.children}
    </footerProvider.Provider>
  );
};
